import Slider from "rc-slider";

const NumberSliderFilter = (props) => {

  let { min=0, max=100, step=1, defaultValue=0, value, onChange, plusMinus } = props;

  const renderSlider = () => {
    return (
      <Slider
        value={value}
        min={min}
        max={max}
        step={step}
        defaultValue={defaultValue}
        onChange={onChange}
        trackStyle={[{
          //backgroundColor: '#4285f4',
          backgroundColor: 'var(--bs-primary)',
          backgroundColor1: '#999999',
          height: 8
        }]}
        railStyle={{
          backgroundColor: '#dddddd',
          backgroundColor1: '#f2f2f2',
          height: 8
        }}
        handleStyle={[{
          width: 22,
          height: 22,
          top: '20%',
          border: '1px solid rgb(213, 216, 222)'
        }, {
          width: 22,
          height: 22,
          top: '20%',
          border: '1px solid rgb(213, 216, 222)'
        }]}
      />
    );
  }

  if (plusMinus) {
    // return (
    //   <div className="d-flex flex-row gap-2">
    //     <div onClick={() => onChange(value-step)}><MinusCircleIcon size="lg" color="lightgrey" /></div>
    //     {renderSlider()}
    //     <div onClick={() => onChange(value+step)}><PlusCircleIcon size="lg" color="lightgrey" /></div>
    //   </div>
    // );
  }

  return renderSlider();

}

export default NumberSliderFilter;
